import { PropsWithChildren } from "react"


export const SectionTitle = ({ children }: PropsWithChildren) => {
    return <h2 className="font-bold flex items-center gap-1">
        {children}
    </h2>
}